import React, { PureComponent } from "react";

export default class RU extends PureComponent {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="13"
        viewBox="0 0 512 341.34"
      >
        <g transform="translate(0 -85.33)">
          <path d="M0,85.33V426.662H512V85.33Z" fill="#f0f0f0" />
          <rect
            width="512"
            height="341.337"
            transform="translate(0 85.333)"
            fill="#0052b4"
          />
          <rect
            width="512"
            height="113.775"
            transform="translate(0 85.333)"
            fill="#f0f0f0"
          />
          <rect
            width="512"
            height="113.775"
            transform="translate(0 312.884)"
            fill="#d80027"
          />
        </g>
      </svg>
    );
  }
}
